"use client";

import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

function CpAuthLayout({
  step = "",
  title = "",
  description = "",
  onBack = () => { },

  leftContent,
  rightCardContent,

  hideRightSection = false,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (step === 1) {
      navigate("/");
    } else {
      onBack();
    }
  };

  return (
    <div className="lg:h-screen w-full flex bg-foundation-beige lg:px-40 lg:pt-20 lg:overflow-hidden relative">

      {/* TOP LOGO */}
      <div className="hidden lg:block absolute left-1/2 -translate-x-1/2 -translate-y-2 bg-black top-6 h-12 px-4 py-2 rounded-full z-50">
        <img
          src="/images/logos/beige_logo_vb.png"
          alt="BEIGE"
          className="h-8 w-auto object-contain"
        />
      </div>

      {/* MAX WIDTH WRAPPER */}
      <div className="mx-auto w-full max-w-[1440px] rounded-t-2xl overflow-hidden shadow-2xl bg-white">

        {/* GRID */}
        <div
          className={`grid lg:h-full lg:overflow-hidden ${hideRightSection
            ? "grid-cols-1"
            : "grid-cols-1 lg:grid-cols-2"
            }`}
        >

          {/* LEFT SECTION */}
          <div
            className="py-14 px-6 md:p-14 flex flex-col bg-white h-full lg:overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
          >
            {/* HEADER */}
            {!hideRightSection && (
              <div className="flex flex-col gap-6">
                <div className="flex justify-between items-center">
                  <button
                    type="button"
                    onClick={handleBack}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-black/10 hover:bg-black/5"
                  >
                    <ArrowLeft className="w-5 h-5 text-black" />
                  </button>
                  <div className="block lg:hidden bg-black top-6 h-12 px-4 py-2 rounded-full z-50">
                    <img
                      src="/images/logos/beige_logo_vb.png"
                      alt="BEIGE"
                      className="h-8 w-auto object-contain"
                    />
                  </div>
                </div>


                <div className="mt-2">
                  {step && (
                    <p className="text-gray-500 font-medium text-sm">
                      {step}
                    </p>
                  )}
                  {title && (
                    <h1 className="text-4xl font-semibold mt-1">
                      {title}
                    </h1>
                  )}
                  {description && (
                    <p className="text-gray-500 mt-2">
                      {description}
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* CONTENT */}
            <div className="mt-6 lg:mt-10">
              {leftContent}
            </div>
          </div>


          {/* RIGHT SECTION (REMOVED ON STEP 4) */}
          {!hideRightSection && (
            <div className="relative bg-[#080912] min-h-[500px] lg:min-h-0 rounded-2xl lg:rounded-none flex items-center justify-center mb-14 lg:mb-0 mx-4 lg:mx-0 lg:overflow-hidden p-4 md:p-6 lg:px-14 lg:pt-[120px] lg:pb-0">

              {/* BACKGROUND GLOW */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[120%] h-[40%] bg-white/5 blur-[90px]" />

              {/* CARD WRAPPER */}
              <div className={`relative z-10 w-full shadow-xl rounded-2xl h-auto min-h-[400px] my-24 lg:border-none bg-white/90 lg:backdrop-blur-xl lg:rounded-t-2xl lg:rounded-b-none lg:h-full lg:my-0 lg:overflow-hidden`}>
                {/* SCROLLABLE CONTENT */}
                <div className="h-full p-5 pb-20 lg:p-6 lg:overflow-y-auto lg:[&::-webkit-scrollbar]:hidden lg:[-ms-overflow-style:none] [scrollbar-width:none]">
                  {rightCardContent}
                </div>

                {/* FADE EFFECT */}
                <div className={`pointer-events-none absolute left-0 w-full h-[150px] lg:h-24 bottom-0 bg-gradient-to-t from-[#080912] to-transparent lg:bottom-0 lg:from-black/80 lg:to-transparent`} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CpAuthLayout;
